const { largeComponentHeight } = require("./const");

export const shortButtonStyle = {
  width: "8rem",
  minWidth: "8rem",
  height: largeComponentHeight,
  whiteSpace: "pre-line",
};
